export const ContractAccountStop = (props, context) => {
  const close = () => {
    context.emit('close')
  }
  const submit = () => {
    context.emit('submit')
  }

  return {
    close,
    submit
  }
}
